import { applyOverrides, counterpartyTCCard } from '../../../shared';

export const buyerTCCard = applyOverrides(counterpartyTCCard, {
  id: 'buySideContacts.buyersTC',
  innerTitle: "Tenant's Transaction Coordinator",
  outerTitle: "Tenant's Transaction Coordinators",
  addableTitle: "Tenant's Transaction Coordinator",
});
